import { GET_ETC_MISSING, 
    GET_ETC_MISSING_SUCCESS,
    SHOW_ETC_Missing_MESSAGE,
    ON_SHOW_ETC_Missing_LOADER ,
    ON_HIDE_ETC_Missing_LOADER,
    HIDE_ETC_Missing_MESSAGE,
    ON_ADD_ETC_Missing,
    ON_ADD_ETC_Missing_Success} from "../../constants/ActionTypes";

export const getEtcMissing = (pageIndex, searchText) => {
    return {
        type: GET_ETC_MISSING,
        payload: {
            pageIndex: pageIndex,
            searchText: searchText
        }
    };
};
export const getEtcMissingSuccess = (data) => {
    return {
        type: GET_ETC_MISSING_SUCCESS,
        payload: data,
    };
};

// export const showMissionLoader = () => {
//     return {
//       type: SHOW_Missing_MESSAGE,
//     };
//   };
  
  export const hideEtcMissingMessage = () => {
    return {
      type: HIDE_ETC_Missing_MESSAGE,
    };
  };
  export const hideEtcMissionLoader = () => {
    return {
      type: ON_HIDE_ETC_Missing_LOADER,
    };
  };
  
  export const showEtcMissionMessage = (message) => {
    return {
      type: ON_SHOW_ETC_Missing_LOADER,
      payload: message
    };
  };
  
  export const AddEtcMission = (mission) => {
    return {
      type: ON_ADD_ETC_Missing,
      payload: mission
    };
  };

  export const AddEtcMissionSuccess = (missionId) => {
    return {
      type: ON_ADD_ETC_Missing_Success,
      payload: missionId
    };
  };